<template>
  <a-layout-header
    class="app-header"
    :style="headerWidth"
  >
    <a-icon
      class="trigger"
      :type="collapsed ? 'menu-unfold' : 'menu-fold'"
      @click="toggleCollapsedHandler"
    />
    <div class="right-top">
      <a-menu
        class="top-menus"
        mode="horizontal"
        :defaultSelectedKeys="topMenuKeys"
        @click="setSubMenuList"
      >
        <a-menu-item
          v-for="(menu, id) in menuList"
          :key="id"
        >
          {{menu.meta.title}}
        </a-menu-item>
      </a-menu>
      <div class="user-menus">
        <!--      <a-avatar style="backgroundColor:#87d068;margin-left: 20px;" icon="user" />-->
        <UserMenu></UserMenu>
      </div>
    </div>
  </a-layout-header>
</template>

<script>
import UserMenu from '@/components/UserMenu/UserMenu'
export default {
  name: 'AppHeader',
  components: {
    UserMenu
  },
  props: {
    collapsed: {
      type: Boolean,
      default: false
    },
    menuList: {
      type: Array,
      required: true
    },
    topMenuKeys: {
      type: Array,
      required: true
    }
  },
  computed: {
    headerWidth () {
      const style = {
        position: 'absolute',
        background: '#fff',
        width: 'calc(100% - 200px)'
      }
      this.collapsed ? style.width = 'calc(100% - 80px)' : style.width = 'calc(100% - 257px)'
      return style
    }
  },
  methods: {
    toggleCollapsedHandler () {
      this.$emit('toggle-collapsed')
    },
    setSubMenuList ({ key }) {
      const item = this.menuList[key]
      !this.$route.path.includes(item.path) &&
      this.$emit('set-sub-menu', item)
    }
  }
}
</script>

<style scoped lang="less" type="text/less">
.app-header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  box-shadow: 0 1px 4px rgba(0,21,41,.08);
  .right-top {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    .top-menus {
      margin-right: 20px;
    }
  }

  .trigger {
    /*display: flex;*/
    /*flex: 1;*/
    font-size: 18px;
    cursor: pointer;
    transition: color 0.3s;

    &:hover {
      color: #1890ff;
    }
  }
}

</style>
